import React from "react";

function AddCarretRightSVG({ color = "#ACADB9", ...other }) {
    return <svg {...other} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path fill={color} fillRule="nonzero" d="M9.5 15.445L12.945 12 9.5 8.555 10.555 7.5l4.5 4.5-4.5 4.5z"/>
    </svg>
}

export default React.memo(AddCarretRightSVG);
